import { getToken } from '../lib/token';
import type { ApiErrorBody, ApiPath } from './types';

export class DownloadError extends Error {
  constructor(message: string, public readonly status: number) {
    super(message);
    this.name = 'DownloadError';
  }
}

export async function downloadFile(path: ApiPath, filename: string): Promise<void> {
  const token = getToken();

  const response = await fetch(path, {
    headers: token ? { Authorization: token } : undefined,
  });

  if (!response.ok) {
    // Ошибка приходит JSON-ом, а не файлом. Читаем как текст:
    // response.json() упадёт, если бэк или Caddy отдали HTML (502, страница Flask).
    const text = await response.text();
    let message = `Не удалось скачать файл (${response.status})`;
    try {
      message = (JSON.parse(text) as ApiErrorBody).message ?? message;
    } catch {
      /* не JSON — оставляем сообщение по коду */
    }
    throw new DownloadError(message, response.status);
  }

  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove(); // в старом downloadFile элемент оставался висеть в DOM
  URL.revokeObjectURL(url);
}
